<template>
  <modal
    title="Associte Accounts"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="input-wrapper my-2">
      <label for="bussiness" class="">Location:</label>
      <input
        type="text"
        id="bussiness"
        class="input"
        placeholder="--Select Location--"
      />
    </div>
    <div class="input-wrapper">
      <label for="categories" class="">Pay Categories:</label>
        <el-select multiple v-model="category"  placeholder="--Select --">
            <el-option
            label="invoice"
            value="invoice"
            >
            </el-option>
            <el-option
            label="Credit Note"
            value="Credit-note"
            >
            </el-option>
        </el-select>
    </div>
    <div class="input-wrapper my-2">
      <label for="acct_no" class="">Account:</label>
        <el-select multiple v-model="account"  placeholder="--Select --">
            <el-option
            label="33848847 | GTB"
            value="gtb"
            >
            </el-option>
            <el-option
            label="8490494310 | UBA"
            value="gtb"
            >
            </el-option>
        </el-select>
    </div>

    <hr class="my-2"/>

    <p class="text-primary-yellow cursor-pointer">
        + Add Location
    </p>

    <div class="button-wrapper mt-5">
      <primary-button buttonText="Update"/>
      <p class="cursor-pointer pt-2 pr-3 mb-0" @click="closeModal">Close</p>
    </div>
  </modal>
</template>

<script>
export default {
  props: ["showModal"],
  data() {
    return {
     category: "",
     account: ""
    };
  },
  methods:{
    closeModal() {
      this.$emit("close-modal");
    }
  }
};
</script>
